import {
  UPDATE_REVIEW_DATE_REQUEST,
  UPDATE_REVIEW_DATE_SUCCESS,
  UPDATE_REVIEW_DATE_ERROR,
  GET_DETAILS_REQUEST,
  GET_DETAILS_SUCCESS,
  GET_DETAILS_ERROR,
  UPDATE_WORKLOAD_EDITION_REQUEST,
  UPDATE_WORKLOAD_EDITION_SUCCESS,
  UPDATE_WORKLOAD_EDITION_ERROR,
  UPDATE_AUTO_FEED_ACTUALS_REQUEST,
  UPDATE_AUTO_FEED_ACTUALS_SUCCESS,
  UPDATE_AUTO_FEED_ACTUALS_ERROR,
  GET_PORTFOLIO_SUCCESS,
  UPDATE_DETAILS_REQUEST,
  UPDATE_DETAILS_SUCCESS,
  UPDATE_DETAILS_ERROR,
  GET_PORTFOLIO_OPTIONS,
  ADD_PORTFOLIO_OPTION,
  PORTFOLIO_ASSIGNMENTS_CHANGED,
} from "../types";

const initialState = {
  details: {},
  currentScenarioName: "",
  options: [],
  assignmentsVersion: 0,
  displayUnitsRevision: 0,
  loading: false,
  error: "",
};

// What a Duration / Work cell depends on. Hours per day counts as its
// effective value: the Daily FTE when the portfolio aligns on it.
const displayUnitsSignature = (maybeDetails) => {
  const details = maybeDetails ?? {};
  return [
    details.durationDisplayUnit,
    details.workDisplayUnit,
    details.daysPerWeek,
    details.daysPerMonth,
    details.hoursPerDayUseDailyFte ? details.dailyFTE : details.hoursPerDay,
  ].join("|");
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const next = reduce(state, action);
  if (next === state) return state;
  // Mounted grids repaint on this counter rather than on each field: it
  // moves once per change of the display units, whichever action brought it.
  return displayUnitsSignature(next.details) === displayUnitsSignature(state.details)
    ? next
    : { ...next, displayUnitsRevision: state.displayUnitsRevision + 1 };
}

function reduce(state, { type, payload }) {
  switch (type) {
    case GET_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PORTFOLIO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        details: payload,
      };
    case GET_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        details: payload,
        name: payload.name,
      };
    case GET_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case UPDATE_REVIEW_DATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_REVIEW_DATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        details: {
          ...state.details,
          dateOfReview: payload,
        },
      };
    case UPDATE_REVIEW_DATE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case UPDATE_WORKLOAD_EDITION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_WORKLOAD_EDITION_SUCCESS:
      return {
        ...state,
        loading: false,
        details: {
          ...state.details,
          workloadEditionEnabled: payload,
        },
        error: "",
      };
    case UPDATE_WORKLOAD_EDITION_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case UPDATE_AUTO_FEED_ACTUALS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_AUTO_FEED_ACTUALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        details: {
          ...state.details,
          autoFeedActualsEnabled: payload,
        },
      };
    case UPDATE_AUTO_FEED_ACTUALS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case UPDATE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_DETAILS_SUCCESS:
      const { startDate, finishDate } = state.details;
      return {
        ...state,
        loading: false,
        error: "",
        details: {
          ...payload,
          ...(startDate && finishDate && { startDate, finishDate }),
        },
      };
    case UPDATE_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case GET_PORTFOLIO_OPTIONS:
      return {
        ...state,
        loading: false,
        options: payload,
      };
    case PORTFOLIO_ASSIGNMENTS_CHANGED:
      return {
        ...state,
        assignmentsVersion: state.assignmentsVersion + 1,
        assignedPortfolios: payload || state.assignedPortfolios,
      };
    case ADD_PORTFOLIO_OPTION:
      const newOptions = state.options.slice();
      newOptions.push(payload);
      return { ...state, options: newOptions };
    default:
      return state;
  }
}
